export default __webpack_public_path__ + "static/media/bimal.91d7d023.jpeg";